'use client';
import { createContext, useContext, useEffect, useState } from 'react';
import type { ReactNode } from 'react';

type NetworkContextValue = { isOnline: boolean };
const NetworkContext = createContext<NetworkContextValue>({ isOnline: false });

export function NetworkProvider({ children }: { children: ReactNode }) {
  const [isOnline, setIsOnline] = useState(
    typeof navigator === 'undefined' ? false : navigator.onLine
  );

  useEffect(() => {
    const handleOnline = () => { setIsOnline(true); };
    const handleOffline = () => { setIsOnline(false); };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Sync once on mount (some browsers may have changed between SSR and hydration)
    setIsOnline(navigator.onLine);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return <NetworkContext.Provider value={{ isOnline }}>{children}</NetworkContext.Provider>;
}

export const useNetwork = () => useContext(NetworkContext);
